export default "__VITE_ASSET__DGtQeynI__"